import React, {useState, useEffect, Fragment} from 'react'
import {Button, Card, Col, Container, Form, Row, Modal} from 'react-bootstrap'
import { MdAccountBox } from "react-icons/md";
import { GiLetterBomb, GiMoneyStack } from "react-icons/gi";
import { BsBank } from "react-icons/bs";
import { AiOutlineMenuUnfold } from "react-icons/ai";
import { AiOutlineFileSearch } from "react-icons/ai";
import { BiDollarCircle } from "react-icons/bi";
import { useSelector} from 'react-redux'
import { CartaCIAComponent, IngresoRecobroComponent, TrazabilidadHitosComponent, CarpetaDigitalComponent} from 'reccol-caso-general'
import { ConsultaProcesosJudicialesComponent, ConsultaGastosHonorariosComponent, ConsultaContactoImplicadoComponent } from 'defcol-caso-general';
import SpeedDial from '@material-ui/lab/SpeedDial'
import SpeedDialAction from '@material-ui/lab/SpeedDialAction'
import {makeStyles} from '@material-ui/core/styles'
import { useLocation, useNavigate } from 'react-router-dom'
import { formatoMonto, isValidParam, formato_rut } from '../../common/Formatos';
import Bitacora from '../bitacora';
import Mensajes from '../mensajes';

const useStyles = makeStyles((theme) => ({
    root: {
     height: 380,
      transform: 'translateZ(0px)',
      flexGrow: 1,
    },
    speedDial: {
        position: 'absolute',
        top: '200px',
        right: '-60px',
        zIndex: '150',
        /* marginTop: '-250px', */
        /* right: theme.spacing(5), */        
    },
    menu: {
      width: '50px',
      height: '50px',
    },
    tooltip: {
        fontSize: '12px',
        backgroundColor: 'black',
        color: 'white'
    }
}));
const useStylesToltip = makeStyles((theme) => ({
  tooltip: {
      fontSize: '12px',
      backgroundColor: 'black',
      color: 'white'
  }
}));
const Formulario = ({formik, setShowToast, showToast, loading}) => {
const {state}=useLocation()
const queryState=JSON.parse(localStorage.getItem('filtrosAreaGestion'))
const history =useNavigate()

const classes = useStyles();  
const classesTooltip = useStylesToltip();
  
const [open, setOpen] = React.useState(false);
const [hidden, setHidden] = React.useState(false);
const [showCIA, setShowCIA] = useState(false)
const [showIngreso, setShowIngreso] = useState(false)
const [showTraza, setShowTraza] = useState(false)
const [showBitacora, setShowBitacora] = useState(false)
const [comentario, setComentario] = useState('')
const [showCarpeta, setShowCarpeta] = useState(false)
const [fechaOcurrencia, setFechaOcurrencia] = useState("")

const handleShowBitacora = () => setShowBitacora(true)
const handleCloseBitacora= () => setShowBitacora(false)

const handleCloseCIA = () => setShowCIA(false)
const handleCloseTraza = () => setShowTraza(false)

const handleShowCIA = () => setShowCIA(true)
const handleShowTraza = () => setShowTraza(true)
const handleShowCarpeta = () => setShowCarpeta(true)
const handleCloseCarpeta= () => setShowCarpeta(false)

const handleShowIngreso = () => setShowIngreso(true)
const handleCloseIngreso= () => setShowIngreso(false)

const [showProcesosJudiciales, setShowProcesosJudiciales] = useState(false);
const handleShowProcesosJudiciales = () => setShowProcesosJudiciales(true)

const [showGastosHonorarios, setShowGastosHonorarios] = useState(false);
const handleShowGastosHonorarios = () => setShowGastosHonorarios(true)

const [showContactoImplicado, setShowContactoImplicado] = useState(false);
const handleShowContactoImplicado = () => setShowContactoImplicado(true)
  
  const handleOpen = () => {
    setOpen(true);
  };
  const handleCloseAction = () => {
    setOpen(false);
  };
  const handleAction = (action) => {
    if(action ==="14_10"){
        handleShowContactoImplicado() 

    } else if(action ==="14_11"){
      
        handleShowCIA()       
    } else if(action ==="14_12"){
      
        handleShowSolicitud()             
    } else if(action ==='14_13'){
     
        handleShowProcesosJudiciales() 
    } else if(action ==='14_14'){
     
        handleShowTraza() 
    } else if(action ==='36_27'){
     
        handleShowIngreso() 
    } else if(action ==='14_23'){
     
        handleShowGastosHonorarios() 
     }
  
  };

    const data_confirmar = useSelector((state) => state.confirmarIngresoRecobroReducer)
    const {cfg_form36, antecedentesRecobro, respuestaConfirmar} = data_confirmar
    const ultimoRecobro = antecedentesRecobro && antecedentesRecobro.antecedentesRecobro.recobros && antecedentesRecobro.antecedentesRecobro.recobros[0];

    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer)
    const {llaves} = data_encargado

    useEffect(()=>{
        if(respuestaConfirmar && respuestaConfirmar.respuestaConfirmar["code"]===1){
           setTimeout(()=> history('/area-gestion-compania',{state:{queryState}}), 2000)      
        }
    },[respuestaConfirmar])

    const actions = [
        { icon: <AiOutlineFileSearch  size={30} style={{color:'#00aeab'}}/>, name: cfg_form36 ? cfg_form36.cfg_form36['confirmaingrerecupero-menu-lateral-hitos' ]:'',id:'14_14'},
        { icon: <BiDollarCircle  size={35} style={{color:'#00aeab'}}/>,  name: cfg_form36 ? cfg_form36.cfg_form36['confirmaingrerecupero-menu-lateral-ingrecobro']:'', id:'36_27'},
        { icon: <GiLetterBomb  size={40} style={{color:'#00aeab'}}/>, name: cfg_form36 ? cfg_form36.cfg_form36['confirmaingrerecupero-menu-lateral-carta']:'',id:'14_11' },
        { icon: <GiMoneyStack  size={35} style={{color:'#00aeab'}}/>,  name: cfg_form36 ? cfg_form36.cfg_form36['confirmaingrerecupero-menu-lateral-gastos']:'', id:'14_23'} ,
        { icon: <BsBank  size={30} style={{color:'#00aeab'}}/>, name: cfg_form36 ? cfg_form36.cfg_form36['confirmaingrerecupero-menu-lateral-antecjud']:'' ,id:'14_13'},     
        { icon: <MdAccountBox  size={35} style={{color:'#00aeab'}}/>,  name: cfg_form36 ? cfg_form36.cfg_form36['confirmaingrerecupero-menu-lateral-ctotro']:'', id:'14_10'}
      ];

      const hoy = () => {
        const fecha = new Date()
        const hoy = fecha.toISOString().split('T')[0]
        return hoy
      }
      const handleCloseToast = () => {
        setShowToast(false);
      }
       return (
        <>
            <style type='text/css'>
        {`
        .cardHeader {
            background-color: #77789b;
            color: #FFFFFF;
          }
        .btn-carpeta {
            background-color: #F0AD3E;
            color: #FFFFFF;
            width: 140px;        
        }
        .btn-carpeta:hover{
            background-color:#e1b97f;
            color: #FFFFFF;
        }
        .btn-bitacora {
            background-color: #55B2CE;
            color: #FFFFFF;
            width: 140px;
        }
        .btn-bitacora:hover{
            background-color: #87c9dc;
            color: #FFFFFF;
        } 
        .btn-cambiar {
            background-color:  #286FBF;
            color: #FFFFFF;
            width: 140px;     
            padding:6px 0px 6px 0px;
        }
        .btn-cambiar:hover{
            background-color:  #5b9ad1;
            color: #FFFFFF;
        }
        .btn-confirmar {
            background-color: #C14B49;
            color: #FFFFFF;
            width: 140px;
            padding:6px 0px 6px 0px;
        }
        .btn-confirmar:hover{
            background-color:  #F6897E;
            color: #FFFFFF;
        }
        .btn-recepcionar {
            background-color: #C14B49;
            color: #FFFFFF;
            width: 140px;
            padding:6px 0px 6px 0px;
        }
        .btn-recepcionar:hover{
            background-color: #F6897E;
            color: #FFFFFF;
        }
        .btn-volver {
            color: #66CCCC;
            border: 1px solid #C00    
            width: 140px;
        }
        .btn-tamano{
            padding: 1rem 1.5rem;
            font-size: 1.5rem;
    }
    `}
      </style>
      <Bitacora
        handleCloseBitacora={handleCloseBitacora}
        showBitacora={showBitacora}
      />      
       <Modal show={showCIA} onHide={handleCloseCIA} size='xl'>
        <CartaCIAComponent handleClose={handleCloseCIA} 
            idCaso={llaves && llaves['idCaso']}
            idImplicado={llaves && llaves['idImplicado']}
            idOrganizacionCaso={8600399880}
        />          
      </Modal>
      <Modal show={showIngreso} onHide={handleCloseIngreso} size="xl">              
        <IngresoRecobroComponent handleClose={handleCloseIngreso} 
            idCaso={llaves && llaves['idCaso']}
            idImplicado={llaves && llaves['idImplicado']}
            idOrganizacionCaso={llaves && llaves['idOrgCaso']}        
          />     
      </Modal>
      <Modal show={showTraza} onHide={handleCloseTraza} size='xl' >
        <TrazabilidadHitosComponent handleClose={handleCloseTraza} 
            idCaso={llaves && llaves['idCaso']}
            idImplicado={llaves && llaves['idImplicado']}
            idOrganizacionCaso={llaves && llaves['idOrgCaso']}
        />          
      </Modal>
      <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">              
        <CarpetaDigitalComponent handleClose={handleCloseCarpeta} 
            idCaso={llaves && llaves['idCaso']}
            idImplicado={llaves && llaves['idImplicado']}
            idOrganizacionCaso={llaves && llaves['idOrgCaso']}
            prototipo={2}            
          />          
    </Modal>
    <ConsultaContactoImplicadoComponent
          idCaso={llaves?.idCaso}
          idOrgCaso={llaves?.idOrgCaso}
          tipoGestion={207001}//{antecedentesCaso && antecedentesCaso[0]?.IdTipoGestion}
          showModal={showContactoImplicado}
          setShowModal={setShowContactoImplicado}
      />
    <ConsultaProcesosJudicialesComponent
        idCaso={llaves?.idCaso}
        idOrgCaso={llaves?.idOrgCaso}
        tipoGestion={207001}//{antecedentesCaso && antecedentesCaso[0]?.IdTipoGestion}
        showModal={showProcesosJudiciales}
        setShowModal={setShowProcesosJudiciales}
    />
    <ConsultaGastosHonorariosComponent
          idCaso={llaves?.idCaso}
          idOrgCaso={llaves?.idOrgCaso}
          showModal={showGastosHonorarios}
          setShowModal={setShowGastosHonorarios}
    />
    <Container className='mb-4 mt-2 position-relative'>
      <div>          
            <SpeedDial
                ariaLabel="SpeedDial tooltip example"
                className={classes.speedDial}
                hidden={hidden}
                icon={<AiOutlineMenuUnfold size={30} />}
                onClose={handleCloseAction}
                onOpen={handleOpen}
                open={true}            
            >
            { actions.map((action) => (
                <SpeedDialAction
                    key={action.id}
                    icon={action.icon}
                    tooltipTitle={action.name}
                    className={classes.menu}                
                    onClick={()=>handleAction(action.id)}
                    TooltipClasses={classesTooltip}
                />            
            ))}
            </SpeedDial>
            </div>

            <Card>
                <Card.Header className='mt-0 mb-0' as='h6'
                    style={
                        {
                            backgroundColor: '#4F517A',
                            color: 'white'
                        }
                }>
                    {
                    cfg_form36 ? cfg_form36.cfg_form36['confirmaingrerecupero-title-antec'] : ''
                } </Card.Header>
                <Container>
                    <Container> {
                        cfg_form36 ? (
                            <div>

                                <Row>
                                    
                                    <Col md='3'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form36.cfg_form36['confirmaingrerecupero-lbl-ambito']
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {antecedentesRecobro &&
                                            isValidParam(antecedentesRecobro.antecedentesRecobro['glosaAmbitoGestion']) ? antecedentesRecobro.antecedentesRecobro['glosaAmbitoGestion'] : '' }
                                        </Form.Text>

                                       </Col>
                                    <Col md='2'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form36.cfg_form36['confirmaingrerecupero-lbl-moneda']
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {antecedentesRecobro &&
                                            isValidParam(antecedentesRecobro.antecedentesRecobro['glosaMoneda']) ? antecedentesRecobro.antecedentesRecobro['glosaMoneda'] : '' }
                                        </Form.Text>

                                       </Col>
                                    <Col md='2'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form36.cfg_form36['confirmaingrerecupero-lbl-mtoneto'] 
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {antecedentesRecobro &&
                                            isValidParam(antecedentesRecobro.antecedentesRecobro['montoNeto']) ? formatoMonto(antecedentesRecobro.antecedentesRecobro['montoNeto']) : '' }                                            
                                        </Form.Text>

                                    </Col>
                                    <Col md='2'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form36.cfg_form36['confirmaingrerecupero-lbl-porcrecupero'] 
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {antecedentesRecobro &&
                                            isValidParam(antecedentesRecobro.antecedentesRecobro['porcRecupero']) ? antecedentesRecobro.antecedentesRecobro['porcRecupero'] : '' }                                            
                                        </Form.Text>

                                    </Col>
                                    <Col md='2'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form36.cfg_form36['confirmaingrerecupero-lbl-mtorecobro'] 
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {antecedentesRecobro &&
                                            isValidParam(antecedentesRecobro.antecedentesRecobro['montoRecobro']) ? formatoMonto(antecedentesRecobro.antecedentesRecobro['montoRecobro']) : '' }                                            
                                        </Form.Text>

                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12">
                                    <div className='d-flex flex-row justify-content-space-beetwen'>
                                        <Form.Label className='mb-0 mt-3'
                                                style={
                                                    {
                                                        fontWeight: 'bold',
                                                        fontSize: '16px',
                                                        width:'200px',
                                                    }
                                            }>
                                                {
                                                    cfg_form36.cfg_form36['confirmaingrerecupero-subtitle1-situacion'] 
                                            } </Form.Label>
                                    
                                            <hr style={
                                                {
                                                    color: '#04005D',
                                                    height: '2px',
                                                    width:'82%',                                                  
                                                    marginTop: '30px'
                                                }
                                            }></hr>
                                    </div>
                                    </Col>
                                   
                                </Row>
                                <Container>
                                <Row>
                                    <Col md='3'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form36.cfg_form36['confirmaingrerecupero-lbl-convenio']
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {antecedentesRecobro &&
                                            isValidParam(antecedentesRecobro.antecedentesRecobro['idConvenio']) ? antecedentesRecobro.antecedentesRecobro['idConvenio'] : '' }                                           
                                        </Form.Text>

                                       </Col>
                                    <Col md='2'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form36.cfg_form36['confirmaingrerecupero-lbl-fecprimpago']
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {antecedentesRecobro &&
                                            isValidParam(antecedentesRecobro.antecedentesRecobro['fechaPrimerPago']) ? antecedentesRecobro.antecedentesRecobro['fechaPrimerPago'] : '' }                                            
                                        </Form.Text>

                                       </Col>
                                    <Col md='2'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form36.cfg_form36['confirmaingrerecupero-lbl-monedasit']
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {antecedentesRecobro &&
                                            isValidParam(antecedentesRecobro.antecedentesRecobro['moneda']) ? antecedentesRecobro.antecedentesRecobro['moneda'] : '' }                                            
                                        </Form.Text>

                                       </Col>
                                    <Col md='2'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form36.cfg_form36['confirmaingrerecupero-lbl-recingresado'] 
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {antecedentesRecobro &&
                                            isValidParam(antecedentesRecobro.antecedentesRecobro['recobroIngresado']) ? formatoMonto(antecedentesRecobro.antecedentesRecobro['recobroIngresado']) : '' }                                          
                                        </Form.Text>

                                    </Col>
                                    <Col md='2'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form36.cfg_form36['confirmaingrerecupero-lbl-saldo'] 
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {antecedentesRecobro &&
                                            isValidParam(antecedentesRecobro.antecedentesRecobro['saldoRecobro']) ? formatoMonto(antecedentesRecobro.antecedentesRecobro['saldoRecobro']) : '' }
                                        </Form.Text>
                                    </Col>
                                    <Col md='2'>
                                        
                                    </Col>
                                </Row>
                                <Row>
                                <Col md='3'>
                                        
                                        </Col>
                                <Col md='2'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form36.cfg_form36['confirmaingrerecupero-lbl-fechpagofinal']
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {antecedentesRecobro &&
                                            isValidParam(antecedentesRecobro.antecedentesRecobro['fechaUltimoPago']) ? antecedentesRecobro.antecedentesRecobro['fechaUltimoPago'] : '' }                                            
                                        </Form.Text>

                                       </Col>
                                    
                                    <Col md='2'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                            }>
                                            {cfg_form36.cfg_form36['confirmaingrerecupero-lbl-cuotas']} 
                                        </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2 mx-4">
                                        {antecedentesRecobro &&
                                            isValidParam(antecedentesRecobro.antecedentesRecobro['cuotas']) ? antecedentesRecobro.antecedentesRecobro['cuotas'] : '' }                                            
                                        </Form.Text>

                                       </Col>
                                    <Col md='2'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                            }>
                                            {cfg_form36.cfg_form36['confirmaingrerecupero-lbl-cuotasvis']} 
                                        </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2 mx-4">
                                        {antecedentesRecobro &&
                                            isValidParam(antecedentesRecobro.antecedentesRecobro['cuotasVisadas']) ? antecedentesRecobro.antecedentesRecobro['cuotasVisadas'] : '' }                                          
                                        </Form.Text>

                                       </Col>
                                    <Col md='3'>
                                        <Form.Label className='mb-0 mt-3 mx-4'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                            }>
                                            {cfg_form36.cfg_form36['confirmaingrerecupero-lbl-cuotaspend']} 
                                        </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">                                      
                                        {antecedentesRecobro && 
                                                                                    isValidParam(antecedentesRecobro.antecedentesRecobro['cuotasVisadas']) ? formatoMonto(antecedentesRecobro.antecedentesRecobro['cuotasPendientes']) : ''                                       
                                        }
                                        </Form.Text>
                                    </Col>
                                    <Col md='2'>
                                        
                                    </Col>
                                </Row>
                                </Container>                              
                                <Row>
                                    <Col>
                                    <div className='d-flex flex-row'>
                                        <Form.Label className='mb-0 mt-3'
                                                style={
                                                    {
                                                        fontWeight: 'bold',
                                                        fontSize: '16px',
                                                        width:'200px',
                                                    }
                                            }>
                                                {
                                                cfg_form36.cfg_form36['confirmaingrerecupero-subtitle2-recobro'] 
                                            } </Form.Label>
                                            <hr style={
                                                {
                                                    color: '#04005D',
                                                    height: '2px',
                                                    width:'82%',                                                  
                                                    marginTop: '30px'
                                                }
                                            }></hr>
                                    </div>
                                    </Col>
                                </Row>
                                <Container>
                                    <Row>
                                        <Col md='2'>
                                            <Form.Label className='mb-0 mt-3'
                                                style={
                                                    {
                                                        fontWeight: 'bold',
                                                        fontSize: '14px'
                                                    }
                                            }>
                                                {
                                                cfg_form36.cfg_form36['confirmaingrerecupero-lbl-aviso']
                                            } </Form.Label>
                                            <br/>
                                            <Form.Text className="mt-2">
                                            {antecedentesRecobro && ultimoRecobro && 
                                                isValidParam(ultimoRecobro['nroAviso']) ? ultimoRecobro['nroAviso'] : '' }
                                            </Form.Text>
                                        </Col>
                                        <Col md='2'>
                                            <Form.Label className='mb-0 mt-3'
                                                style={
                                                    {
                                                        fontWeight: 'bold',
                                                        fontSize: '14px'
                                                    }
                                            }>
                                                {
                                                cfg_form36.cfg_form36['confirmaingrerecupero-lbl-fechacaja']
                                            } </Form.Label>
                                            <br/>
                                            <Form.Text className="mt-2">
                                            {antecedentesRecobro && ultimoRecobro && 
                                                isValidParam(ultimoRecobro['fecIngresoCajaFormat']) ? ultimoRecobro['fecIngresoCajaFormat'] : '' }
                                            </Form.Text>
                                        </Col>
                                        <Col md='3'>
                                            <Form.Label className='mb-0 mt-3'
                                                style={
                                                    {
                                                        fontWeight: 'bold',
                                                        fontSize: '14px'
                                                    }
                                            }>
                                                {
                                                cfg_form36.cfg_form36['confirmaingrerecupero-lbl-respingreso'] 
                                            } </Form.Label>
                                            <br/>
                                            <Form.Text className="mt-2">
                                            {antecedentesRecobro && ultimoRecobro && 
                                                isValidParam(ultimoRecobro['responsableIngreso']) ? ultimoRecobro['responsableIngreso'] : '' }
                                            </Form.Text>
                                        </Col> 
                                        <Col md='2'>
                                            <Form.Label className='mb-0 mt-3'
                                                style={
                                                    {
                                                        fontWeight: 'bold',
                                                        fontSize: '14px'
                                                    }
                                            }>
                                                {
                                                cfg_form36.cfg_form36['confirmaingrerecupero-lbl-idrespgestion'] 
                                            } </Form.Label>
                                            <br/>
                                            <Form.Text className="mt-2">
                                            {antecedentesRecobro && ultimoRecobro && 
                                                isValidParam(ultimoRecobro['idResponsableGestion']) ? formato_rut(ultimoRecobro['idResponsableGestion']) : '' }
                                            </Form.Text>
                                       </Col>
                                       <Col md='3'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form36.cfg_form36['confirmaingrerecupero-lbl-respgestion'] 
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {antecedentesRecobro && ultimoRecobro &&
                                            isValidParam(ultimoRecobro['responsableGestion']) ? ultimoRecobro['responsableGestion'] : '' }
                                        </Form.Text>
                                       </Col>
                                    </Row>
                                    <Row>
                                        <Col md='2'>
                                            <Form.Label className='mb-0 mt-3'
                                                style={
                                                    {
                                                        fontWeight: 'bold',
                                                        fontSize: '14px'
                                                    }
                                            }>
                                                {
                                                cfg_form36.cfg_form36['confirmaingrerecupero-lbl-monpago']
                                            } </Form.Label>
                                            <br/>
                                            <Form.Text className="mt-2">
                                            {antecedentesRecobro && ultimoRecobro && 
                                                isValidParam(ultimoRecobro['glosaMonedaPago']) ? ultimoRecobro['glosaMonedaPago'] : '' }
                                            </Form.Text>
                                        </Col>
                                        <Col md='2'>
                                            <Form.Label className='mb-0 mt-3'
                                                style={
                                                    {
                                                        fontWeight: 'bold',
                                                        fontSize: '14px'
                                                    }
                                            }>
                                                {
                                                cfg_form36.cfg_form36['confirmaingrerecupero-lbl-mtopago']
                                            } </Form.Label>
                                            <br/>
                                            <Form.Text className="mt-2">
                                            {antecedentesRecobro && ultimoRecobro && 
                                                isValidParam(ultimoRecobro['montoPago']) ? formatoMonto(ultimoRecobro['montoPago']) : '' }
                                            </Form.Text>
                                        </Col>
                                        <Col md='3'>
                                            <Form.Label className='mb-0 mt-3'
                                                style={
                                                    {
                                                        fontWeight: 'bold',
                                                        fontSize: '14px'
                                                    }
                                            }>
                                                {
                                                cfg_form36.cfg_form36['confirmaingrerecupero-lbl-periodo'] 
                                            } </Form.Label>
                                            <br/>
                                            <Form.Text className="mt-2">
                                            {antecedentesRecobro && ultimoRecobro && 
                                                isValidParam(ultimoRecobro['periodoContable']) ? ultimoRecobro['periodoContable'] : '' }
                                            </Form.Text>
                                        </Col> 
                                        <Col md='2'>
                                            <Form.Label className='mb-0 mt-3'
                                                style={
                                                    {
                                                        fontWeight: 'bold',
                                                        fontSize: '14px'
                                                    }
                                            }>
                                                {
                                                cfg_form36.cfg_form36['confirmaingrerecupero-lbl-idgirador'] 
                                            } </Form.Label>
                                            <br/>
                                            <Form.Text className="mt-2">
                                            {antecedentesRecobro && ultimoRecobro && 
                                                isValidParam(ultimoRecobro['idGirador']) ? formato_rut(ultimoRecobro['idGirador']) : '' }
                                            </Form.Text>
                                       </Col>
                                       <Col md='3'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form36.cfg_form36['confirmaingrerecupero-lbl-girador'] 
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {antecedentesRecobro && ultimoRecobro && 
                                            isValidParam(ultimoRecobro['girador']) ? ultimoRecobro['girador'] : '' }
                                        </Form.Text>
                                       </Col>
                                    </Row>
                                </Container>
                                <Row>
                                    <Col>
                                        <div className='d-flex flex-row'>                                            
                                                <hr style={
                                                    {
                                                        color: '#04005D',
                                                        height: '2px',
                                                        width:'110%',
                                                        marginLeft:'7rem',
                                                        marginTop: '30px'
                                                    }
                                                }></hr>
                                        </div>
                                    </Col>
                                </Row>
                                <Container>
                                <Row>
                                    <Col md='3'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '16px'
                                                }
                                        }>
                                            {
                                            cfg_form36.cfg_form36['confirmaingrerecupero-subtitle3'] 
                                        } </Form.Label>
                                    </Col>
                                    <Col md="2">
                                        <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {cfg_form36.cfg_form36['confirmaingrerecupero-input-fecha']}
                                        </Form.Label>
                                        <br />
                                        <Form.Control className='mb-0'                                     
                                            type='date'
                                            value={(formik.values.fechaOcurrencia = fechaOcurrencia)}
                                            //min={fechaSiniestro && convertirFecha(fechaSiniestro && fechaSiniestro)}
                                            max={hoy()}
                                            name='fechaOcurrencia'
                                            onChange={(e) => {
                                                formik.handleChange(e)
                                                setFechaOcurrencia(e.target.value)
                                            }}
                                            error={formik.errors.fechaOcurrencia}
                                        >                                        
                                        </Form.Control>
                                            {formik.errors.fechaOcurrencia ? (
                                            <Form.Text variant='danger' style={{ color: 'red' }}>
                                            {formik.errors.fechaOcurrencia}
                                            </Form.Text>
                                        ) : (
                                            ''
                                        )}           
                                    </Col>                     
                                    <Col md='7'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form36.cfg_form36['confirmaingrerecupero-input-comentario'] +" (*)"
                                        } </Form.Label>
                                        {"\u00A0"}
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '10px'
                                                }
                                            }>
                                        </Form.Label>
                                        <br/>
                                        <Form.Control as="textarea" rows={3} 
                                        className='mt-2 mb-2'
                                            onChange={e=>{                 
                                                formik.handleChange(e)
                                                setComentario(e.target.value)
                                                }}
                                            name='comentario'
                                            value={formik.values.comentario=comentario}
                                            error={formik.errors.comentario}  
                                        />
                                        {formik.errors.comentario ? (<Form.Text variant="danger" style={{color:"red"}} >{formik.errors.comentario}</Form.Text>) :""}

                                       </Col>
                                </Row>
                                </Container>
                                    <Col> 
                                        {respuestaConfirmar && 
                                            <Mensajes
                                                showToast={showToast}
                                                handleCloseToast={handleCloseToast}
                                                delay={5000}
                                                responseData={respuestaConfirmar?.respuestaConfirmar}
                                            ></Mensajes>
                                        }
                                    </Col>
                                </div>                                
                        ) : null
                    } </Container>
                </Container>
                <Container>
                    <Row className='mt-2'>                        
                        <Col className='d-flex align-items-end justify-content-end m-2'>
                            <Button className='m-2 w-auto' variant='outline-info' onClick={()=> history('/area-gestion-compania',{state:{queryState}} )}  >
                                {cfg_form36 && cfg_form36.cfg_form36["confirmaingrerecupero-btn-volver"]}
                            </Button>
                            <Button className='m-2' variant='bitacora' onClick={handleShowBitacora} >
                                {cfg_form36 && cfg_form36.cfg_form36["confirmaingrerecupero-btn-bitacora"]}
                            </Button>
                            <Button className='m-2' variant='carpeta' onClick={handleShowCarpeta} name='carpeta'>
                                {cfg_form36 && cfg_form36.cfg_form36["confirmaingrerecupero-btn-carpeta"]}
                            </Button>                        
                            <Button className='m-2' variant='confirmar' type='onSubmit' name='confirmar'>
                                {cfg_form36 && cfg_form36.cfg_form36["confirmaingrerecupero-btn-confirmar"]}
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Card>
        </Container>
        </>
    )
}

export default Formulario
